import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgCardCode = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 31,
	height: 32,
	viewBox: "0 0 31 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.4468 21.1996L6.59005 15.9996L11.4468 10.7996C11.9325 10.2796 11.9325 9.45297 11.4468 8.93297C10.9612 8.41297 10.189 8.41297 9.70337 8.93297L3.98731 15.053C3.50163 15.573 3.50163 16.413 3.98731 16.933L9.70337 23.0663C10.189 23.5863 10.9612 23.5863 11.4468 23.0663C11.9325 22.5463 11.9325 21.7196 11.4468 21.1996V21.1996ZM19.666 21.1996L24.5228 15.9996L19.666 10.7996C19.1803 10.2796 19.1803 9.45297 19.666 8.93297C20.1517 8.41297 20.9238 8.41297 21.4095 8.93297L27.1255 15.053C27.6112 15.573 27.6112 16.413 27.1255 16.933L21.4095 23.0663C20.9238 23.5863 20.1517 23.5863 19.666 23.0663C19.1803 22.5463 19.1803 21.7196 19.666 21.1996V21.1996Z",
		fill: "#4284F5"
	})
});
export default SvgCardCode;
